import { v4 as v4_ } from 'uuid';

export const v4 = v4_;
